module.exports = __webpack_public_path__ + "img/logo3.cac0e8f8.png";